export default "__VITE_ASSET__621eb6af__"